import { render, staticRenderFns } from "./HeraLangSwitcher.vue?vue&type=template&id=3a6a245a&"
import script from "./HeraLangSwitcher.vue?vue&type=script&lang=js&"
export * from "./HeraLangSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./HeraLangSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports